import { Box } from '@amzn/awsui-components-react';
import React from 'react';

import { constants } from '../../../common/Localization';
import { formatCurrencyNoDecimals, formatNumber } from '../../../common/LocalizationHelper';
import { ColumnDefinition, ColumnTypes } from '../../../common/table/types';
import { roundToInteger } from '../../../common/util';
import { Resource } from './MainframeTypes';

export const MainframeResourceColumnDefinitions: ColumnDefinition<Resource>[] = [
    {
        data: item => item.mainframeName,
        cell: item => item.mainframeName,
        header: constants.WORKLOAD_NAME,
        id: 'mainframeNameId',
        sortingField: 'mainframeName',
        type: ColumnTypes.TEXT,
    },
    {
        data: item => item.isDisasterRecovery,
        cell: item => item.isDisasterRecovery,
        header: constants.DISASTER_RECOVERY_COLUMN_HEADER,
        id: 'isDisasterRecoveryId',
        sortingField: 'isDisasterRecovery',
        type: ColumnTypes.BOOLEAN,
    },
    {
        data: item => item.environmentType,
        cell: item => item.environmentType,
        header: constants.ENVIRONMENT_TYPE,
        id: 'environmentTypeId',
        sortingField: 'environmentType',
        type: ColumnTypes.TEXT,
    },
    {
        data: item => item.resourceName,
        cell: item => item.resourceName,
        header: constants.RESOURCE_NAME,
        id: 'resourceNameId',
        sortingField: 'resourceName',
        type: ColumnTypes.TEXT,
    },
    {
        data: item => item.resourceType,
        cell: item => item.resourceType,
        header: constants.RESOURCE_TYPE,
        id: 'resourceTypeId',
        sortingField: 'resourceType',
        type: ColumnTypes.TEXT,
    },
    {
        data: item => item.unitMonthlyCost ? roundToInteger(item.unitMonthlyCost) : '',
        cell: item => <Box textAlign='right'>{formatCurrencyNoDecimals(item.unitMonthlyCost ?? 0, item.currency)}</Box>,
        header: constants.UNIT_MONTHLY_COST,
        id: 'unitMonthlyCostId',
        sortingField: 'unitMonthlyCost',
        type: ColumnTypes.NUMBER,
    },
    {
        data: item => item.unit,
        cell: item => item.unit,
        header: constants.UNIT,
        id: 'unitId',
        sortingField: 'unit',
        type: ColumnTypes.TEXT,
    },
    {
        data: item => item.count,
        cell: item => (<Box textAlign='right'>{formatNumber(item.count)}</Box>),
        header: constants.COUNT,
        id: 'countId',
        sortingField: 'count',
        type: ColumnTypes.NUMBER,
    },
    {
        data: item => item.monthlyCost ? roundToInteger(item.monthlyCost) : '',
        cell: item => <Box textAlign='right'>{formatCurrencyNoDecimals(item.monthlyCost ?? 0, item.currency)}</Box>,
        header: constants.MONTHLY_COST,
        id: 'monthlyCostId',
        sortingField: 'monthlyCost',
        type: ColumnTypes.NUMBER,
    },
];
